import { createSlice } from "@reduxjs/toolkit";

const initialSettings = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [],
 
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const NewinitialSettings = createSlice({
  name: "newinitialSettings",
  initialState: initialSettings,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    itemCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities = []; // Reset entities to an empty array
    },
    singleItemFetched: (state, action) => {
      state.actionsLoading = false;
      state.packageData = action.payload.data;
      state.error = null;
    },
  },
});
